<template>
  <div id="wechat-login">
    <div
      v-if="showQrCode"
      id="wechat__code"
      v-loading="qrCodeLoading"
      style="text-align: center; height: 310px"
      customClass="loading-all"
      element-loading-custom-class="loading-all"
      element-loading-background="rgba(255, 255, 255,1)"
      element-loading-text="生成登录二维码...请稍等"
    >
      <el-image
        id="invite-qrcode"
        :src="qrcodeSrcWeChat"
        style="height: 250px; width: 250px"
        @error="onQRCodeLoadFailed"
        @load="onQRCodeLoadSuccessfully"
      >
        <span></span>
      </el-image>
    </div>
    <span v-else class="altTipQrCode" @click="clickSpan">二维码失效，点击刷新</span>
  </div>
</template>
<script>
export default {
  name: 'WechatLogin',
  components: {},
  filters: {},
  directives: {},
  mixins: [],
  props: {},
  data() {
    return {
      userToken: '',
      wxURL: '',
      socket: null,
      ticket: '',
      showQrCode: true, // 显示失效信息
      qrcodeSrcWeChat: '',
      qrCodeLoading: true,
    }
  },
  computed: {
    // ...mapState('', {}),
  },
  watch: {},
  async created() {
    this.qrcodeSrcWeChat = ''
    await this.getUrl()
    await this.getSocket()
    await this.chooseWX()
    window.onunload = function deleteTimer() {
      this.socket.close()
      clearInterval(timer)
    }
  },
  mounted() {},
  destroy() {},
  methods: {
    /**
     * 获取微信二维码的链接
     */
    async getUrl() {
      const _ = this
      const { success, data } = await this.$http({
        url: '/api/UserActivation/GetUserActivationUrl',
        method: 'Get',
      })
      if (success) {
        document.getElementsByClassName('el-loading-spinner')[0].style.top = 0
        const loadingText = document.getElementsByClassName('el-loading-text')[0]
        loadingText.style.cssText = 'position:absolute;top:54px;right:30%'
        _.qrCodeLoading = true
        _.wxURL = data.WSURL
      } else {
        this.$message({
          type: 'error',
          message: '微信登录失败！',
        })
      }
    },
    /**
     * 通知server返回信息
     * @param ticket {string} 凭证
     */
    sendSocketTicket(ticket) {
      this.socket.send(
        JSON.stringify({
          Module: 'Common',
          Action: 'SetCurrentUserByUniqueIdentification',
          Param: {
            UniqueIdentification: ticket,
            Channel: 'Web',
          },
        }),
      )
    },
    /**
     * 获取serve返回的信息
     */
    getSocket() {
      const _this = this
      _this.socket = new WebSocket(_this.wxURL)
      _this.socket.addEventListener('message', event => {
        const data = JSON.parse(event.data)
        if (data.Success) {
          _this.userToken = data.Param.Token
          _this.$emit('qrcode-token', _this.userToken)
        }
      })
    },
    clickSpan() {
      this.chooseWX()
    },
    /**
     * 二维码加载成功的回调
     */
    onQRCodeLoadSuccessfully() {
      let count = 0
      this.$nextTick(() => {
        // 通知server
        this.sendSocketTicket(this.ticket)
        // 设置失效逻辑
        const timer = setInterval(() => {
          count++
          if (count >= 1800) {
            clearInterval(timer)
            count = 0
            this.qrcodeSrcWeChat = ''
            this.showQrCode = false
          }
        }, 1e3)
      })
    },
    /**
     *二维码加载失败的回调
     */
    onQRCodeLoadFailed() {},
    /**
     * 获取二维码图片
     */
    async chooseWX() {
      this.showQrCode = true
      const sceneData = 'QRCode_Login_'
      const { success, data } = await this.$http({
        url: '/api/Account/CreateQRCode',
        method: 'post',
        data: {
          expire_seconds: 1800,
          action_name: 'QR_STR_SCENE',
          action_info: {
            scene: {
              scene_str: sceneData,
            },
          },
        },
      })
      if (success) {
        this.ticket = data.Ticket
        this.qrcodeSrcWeChat = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${this.ticket}`
        this.qrCodeLoading = false
        this.sendSocketTicket(data.Ticket)
      } else {
        this.$message({
          type: 'error',
          message: '微信登录失败！',
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped></style>
<style lang="scss">
#wechat-login {
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  justify-content: center;
  height: 310px;
}

.altTipQrCode {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  height: 250px;
  width: 250px;
}
#wechat__code {
  margin: auto;
  text-align: center;
  width: 22rem;
  height: 280px;
  line-height: 280px;
}

.alt-script {
  font-size: 14px;
  color: #606266;
}

.img-middle-item {
  width: 280px;
  height: 280px;
}
.register-span {
  display: inline-block;
}

.impowerBox .title {
  display: none !important;
}
</style>
